module.exports = __webpack_public_path__ + "static/media/mulos.7c8ab6c1.png";